import { useState } from "react";
import styles from "./styles.module.css";
import User from "../../images/user.svg";
import ArrowBottom from "../../images/arrowBottom.svg";
import { Button, Typography } from "antd";
import imgBurger from "../../images/iconBurger.svg";
import { MenuProfile } from "../MenuProfile";
import { useDispatch, useSelector } from "react-redux";
import { getUserData } from "../../store/user/selectors";
import { setOpenFails } from "../../store/fails";
import { setOpenCorrections } from "../../store/corrections";
import { setOpenUserManagement } from "../../store/userManagement";
import { setOpenType } from "../../store/typeComplaints";
import {
  setOpenPlanningCreate,
  setOpenPlanningEdit,
} from "../../store/planning";
import { setOpenInfo } from "../../store/user";
import { setOpenPayments } from "../../store/payments";
import { getOpenPaymentsSelector } from "../../store/payments/selectors";
import {
  setOpenCalculation,
  setCalculationSubmitted,
} from "../../store/calculation";
import { getOpenCalculationSelector } from "../../store/calculation/selectors";
import {
  setOpenCalculationNetwork,
  setCalculationNetworkSubmitted,
} from "../../store/networkCalculation";
import { getOpenCalculationNetworkSelector } from "../../store/networkCalculation/selectors";
import {
  setOpenCalculationPremiums,
  setCalculationPremiumsSubmitted,
} from "../../store/calculationPremiums";
import {
  setOpenCalculationPremiumsNetwork,
  setCalculationPremiumsNetworkPremiumsSubmitted,
} from "../../store/calculationPremiumsNetwork";
import { getOpenCalculationPremiumsSelector } from "../../store/calculationPremiums/selectors";
import { getOpenCalculationPremiumsNetworkSelector } from "../../store/calculationPremiumsNetwork/selectors";
import iconPlus from "../../images/iconPlus.svg";
import iconClose from "../../images/iconClose.svg";
import iconMoney from "../../images/iconMoney.svg";
import Help from "../../images/iconInfo.svg";
import { setOpenSidebar } from "../../store/user";
import { getPlanningData } from "../../store/planning/selectors";
import { setOpenAwardSchemesCreate } from "../../store/awardSchemes";

export const Header = ({ pageId, openSidebar, width }) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const userData = useSelector(getUserData);
  const isOpenPayments = useSelector(getOpenPaymentsSelector);
  const isOpenCalculation = useSelector(getOpenCalculationSelector);
  const isOpenCalculationNetwork = useSelector(
    getOpenCalculationNetworkSelector
  );
  const isOpenCalculationPremiums = useSelector(
    getOpenCalculationPremiumsSelector
  );
  const isOpenCalculationPremiumsNetwork = useSelector(
    getOpenCalculationPremiumsNetworkSelector
  );
  const planningData = useSelector(getPlanningData);
  const currentDate = new Date();
  const planDate = new Date(planningData?.data[0]?.day);
  const isMonthPassed =
    currentDate.getTime() >
    new Date(planDate.getFullYear(), planDate.getMonth() + 1).getTime();

  return (
    <div className={styles.header}>
      <div className={styles.headerBlock}>
        <div className={styles.containerHeader}>
          <div className={styles.container}>
            {width > 640 && (
              <Button
                htmlType="button"
                onClick={() => dispatch(setOpenSidebar(!openSidebar))}
                className={styles.buttonSidebar}
              >
                <img src={imgBurger} alt="burger" />
              </Button>
            )}
            <Typography.Text className={styles.text}>
              {pageId === "complaints" && "Список жалоб"}
              {pageId === "corrections" && "Список коррекций"}
              {pageId === "settings" && "Настройки"}
              {pageId === "user" && "Пользователи сетевого доступа"}
              {pageId === "payments" && "Выплаты"}
              {pageId === "calculation" && "Расчет"}
              {pageId === "calculationNetwork" && "Сетевой расчет"}
              {pageId === "complaintsNetwork" && "Список жалоб сети"}
              {pageId === "correctionsNetwork" && "Список коррекций сети"}
              {pageId === "types" && "Типы жалоб клиентов"}
              {pageId === "staff" && "Сотрудники"}
              {pageId === "staff_create" && "Новый локальный сотрудник"}
              {pageId === "staff_edit" && "Сотрудник"}
              {pageId === "staff_network" && "Сетевые сотрудники"}
              {pageId === "staff_network_edit" && "Сетевой сотрудник"}
              {pageId === "admin" && "Настройки ошибок админа"}
              {pageId === "sattings_planning" && "Настройки планирования"}
              {pageId === "planning" && "Планирование"}
              {pageId === "expenses" && "Сетевые расходы"}
              {pageId === "award_schemes" && "Схемы премий"}
              {pageId === "сalculation_premiums" && "Расчет премий"}
              {pageId === "сalculation_premiums_network" && "Расчет премий"}
              {pageId === "employees_salary" && "Зарплата сотрудника"}
            </Typography.Text>
          </div>
          <Button
            htmlType="button"
            className={styles.buttonHeader}
            onClick={() => setOpen(!open)}
          >
            {width > 640 && (
              <Typography.Text className={styles.textUser}>
                {userData?.external_data?.y_name || userData?.user?.username}
              </Typography.Text>
            )}
            <img src={User} alt="Пользователь" />
            <img src={ArrowBottom} alt="Стрелка" className={styles.arrow} />
          </Button>
          {open && <MenuProfile setOpen={setOpen} />}
        </div>
        <img
          src={Help}
          alt="info"
          className={styles.iconHelp}
          onClick={() => dispatch(setOpenInfo())}
        />
      </div>
      {pageId === "complaints" && (
        <Button
          type="primary"
          htmlType="button"
          className={styles.button}
          onClick={() => dispatch(setOpenFails())}
        >
          <img src={iconPlus} alt="plus" />
          {width > 640 && (
            <span className={styles.button_text}>Новая жалоба</span>
          )}
        </Button>
      )}
      {pageId === "corrections" && (
        <Button
          type="primary"
          htmlType="button"
          className={styles.button}
          onClick={() => dispatch(setOpenCorrections())}
        >
          <img src={iconPlus} alt="plus" />
          {width > 640 && (
            <span className={styles.button_text}>Новая корреция</span>
          )}
        </Button>
      )}
      {pageId === "user" && (
        <Button
          type="primary"
          htmlType="button"
          className={styles.button}
          onClick={() => dispatch(setOpenUserManagement())}
        >
          <img src={iconPlus} alt="plus" />
          {width > 640 && <span className={styles.button_text}>Добавить</span>}
        </Button>
      )}
      {pageId === "payments" && !isOpenPayments && (
        <Button
          type="primary"
          htmlType="button"
          className={styles.button}
          onClick={() => dispatch(setOpenPayments())}
        >
          <img src={iconMoney} alt="money" />
          {width > 640 && (
            <span className={styles.button_text}>Внести в YClients</span>
          )}
        </Button>
      )}
      {pageId === "calculation" &&
        (!isOpenCalculation ? (
          <Button
            type="primary"
            htmlType="button"
            className={styles.button}
            onClick={() => dispatch(setOpenCalculation())}
          >
            <img src={iconPlus} alt="plus" />
            {width > 640 && (
              <span className={styles.button_text}>Оформить выплаты</span>
            )}
          </Button>
        ) : (
          <div
            style={{
              display: "flex",
              gap: 10,
            }}
          >
            <Button
              type="primary"
              htmlType="button"
              className={styles.button}
              style={{ backgroundColor: "#F07878" }}
              onClick={() => {
                dispatch(setOpenCalculation());
                dispatch(setCalculationSubmitted(false));
              }}
            >
              <img src={iconClose} alt="close" />
            </Button>
            <Button
              type="primary"
              htmlType="button"
              className={styles.button}
              style={{ backgroundColor: "#4D7CD6" }}
              onClick={() => {
                dispatch(setOpenCalculation());
                dispatch(setCalculationSubmitted(true));
              }}
            >
              <img src={iconPlus} alt="plus" />
              {width > 640 && (
                <span className={styles.button_text}>Создать выплаты</span>
              )}
            </Button>
          </div>
        ))}
      {pageId === "calculationNetwork" &&
        (!isOpenCalculationNetwork ? (
          <Button
            type="primary"
            htmlType="button"
            className={styles.button}
            onClick={() => dispatch(setOpenCalculationNetwork())}
          >
            <img src={iconPlus} alt="plus" />
            {width > 640 && (
              <span className={styles.button_text}>Оформить выплаты</span>
            )}
          </Button>
        ) : (
          <div
            style={{
              display: "flex",
              gap: 10,
            }}
          >
            <Button
              type="primary"
              htmlType="button"
              className={styles.button}
              style={{ backgroundColor: "#F07878" }}
              onClick={() => {
                dispatch(setOpenCalculationNetwork());
                dispatch(setCalculationNetworkSubmitted(false));
              }}
            >
              <img src={iconClose} alt="close" />
            </Button>
            <Button
              type="primary"
              htmlType="button"
              className={styles.button}
              style={{ backgroundColor: "#4D7CD6" }}
              onClick={() => {
                dispatch(setOpenCalculationNetwork());
                dispatch(setCalculationNetworkSubmitted(true));
              }}
            >
              <img src={iconPlus} alt="plus" />
              {width > 640 && (
                <span className={styles.button_text}>Создать выплаты</span>
              )}
            </Button>
          </div>
        ))}
      {pageId === "types" && (
        <Button
          type="primary"
          htmlType="button"
          className={styles.button}
          onClick={() => dispatch(setOpenType())}
        >
          <img src={iconPlus} alt="plus" />
          {width > 640 && <span className={styles.button_text}>Добавить</span>}
        </Button>
      )}
      {pageId === "staff_edit" && (
        <div style={{ width: 204, height: 36 }}></div>
      )}
      {pageId === "planning" &&
        planningData &&
        !isMonthPassed &&
        (planningData?.summary?.plan === 0 ? (
          <Button
            type="primary"
            htmlType="button"
            className={styles.button}
            onClick={() => dispatch(setOpenPlanningCreate())}
          >
            <img src={iconPlus} alt="plus" />
            {width > 640 && (
              <span className={styles.button_text}>Установить план</span>
            )}
          </Button>
        ) : (
          <Button
            type="primary"
            htmlType="button"
            className={styles.button}
            style={{ backgroundColor: "#4D7CD6" }}
            onClick={() => dispatch(setOpenPlanningEdit())}
          >
            <img src={iconPlus} alt="plus" />
            {width > 640 && (
              <span className={styles.button_text}>Изменить план</span>
            )}
          </Button>
        ))}
      {pageId === "award_schemes" && (
        <Button
          type="primary"
          htmlType="button"
          className={styles.button}
          onClick={() => dispatch(setOpenAwardSchemesCreate())}
        >
          <img src={iconPlus} alt="plus" />
          {width > 640 && (
            <span className={styles.button_text}>Создать схему</span>
          )}
        </Button>
      )}
      {pageId === "сalculation_premiums" &&
        (!isOpenCalculationPremiums ? (
          <Button
            type="primary"
            htmlType="button"
            className={styles.button}
            onClick={() => dispatch(setOpenCalculationPremiums())}
          >
            <img src={iconPlus} alt="plus" />
            {width > 640 && (
              <span className={styles.button_text}>Создать расчет</span>
            )}
          </Button>
        ) : (
          <div
            style={{
              display: "flex",
              gap: 10,
            }}
          >
            <Button
              type="primary"
              htmlType="button"
              className={styles.button}
              style={{ backgroundColor: "#F07878" }}
              onClick={() => {
                dispatch(setOpenCalculationPremiums());
                dispatch(setCalculationPremiumsSubmitted(false));
              }}
            >
              <img src={iconClose} alt="close" />
            </Button>
            <Button
              type="primary"
              htmlType="button"
              className={styles.button}
              style={{ backgroundColor: "#4D7CD6" }}
              onClick={() => {
                dispatch(setOpenCalculationPremiums());
                dispatch(setCalculationPremiumsSubmitted(true));
              }}
            >
              <img src={iconPlus} alt="plus" />
              {width > 640 && (
                <span className={styles.button_text}>Создать расчет</span>
              )}
            </Button>
          </div>
        ))}
      {pageId === "сalculation_premiums_network" &&
        (!isOpenCalculationPremiumsNetwork ? (
          <Button
            type="primary"
            htmlType="button"
            className={styles.button}
            onClick={() => dispatch(setOpenCalculationPremiumsNetwork())}
          >
            <img src={iconPlus} alt="plus" />
            {width > 640 && (
              <span className={styles.button_text}>Создать расчет</span>
            )}
          </Button>
        ) : (
          <div
            style={{
              display: "flex",
              gap: 10,
            }}
          >
            <Button
              type="primary"
              htmlType="button"
              className={styles.button}
              style={{ backgroundColor: "#F07878" }}
              onClick={() => {
                dispatch(setOpenCalculationPremiumsNetwork());
                dispatch(setCalculationPremiumsNetworkPremiumsSubmitted(false));
              }}
            >
              <img src={iconClose} alt="close" />
            </Button>
            <Button
              type="primary"
              htmlType="button"
              className={styles.button}
              style={{ backgroundColor: "#4D7CD6" }}
              onClick={() => {
                dispatch(setOpenCalculationPremiumsNetwork());
                dispatch(setCalculationPremiumsNetworkPremiumsSubmitted(true));
              }}
            >
              <img src={iconPlus} alt="plus" />
              {width > 640 && (
                <span className={styles.button_text}>Создать расчет</span>
              )}
            </Button>
          </div>
        ))}
    </div>
  );
};
